<template>
    <div>
        <template v-if="myCorrections !== null">
            <div class="clearfix">
                <div class="page-top mb-1 mb-3 align-center clearfix">
                    <h1 class="float-left"> My Correction </h1>
                </div>

                <div class="page-top mb-1 mb-3 clearfix">
                    <ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="approved-tab" data-toggle="tab" href="#approved" role="tab" aria-controls="new" aria-selected="true">Approved ({{approved}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="pending-tab" data-toggle="tab" href="#pending" role="tab" aria-controls="new" aria-selected="true">Pending ({{pending}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="rejected-tab" data-toggle="tab" href="#rejected" role="tab" aria-controls="new" aria-selected="true">Rejected ({{rejected}})</a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="approved" role="tabpanel" aria-labelledby="approved-tab">
                        <table id="dt-approved" class="table">
                            <thead>
                                <tr>
                                    <th>Created At</th>
                                    <th>Correction Date</th>
                                    <th>Time IN</th>
                                    <th>Time OUT</th>
                                    <th>Line Manager</th>
                                    <th>Status</th>
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead> 
                            <tbody>
                                <tr v-for="apl in myCorrections" :key="apl.id" v-if="apl.status == 'APPROVED_HR'">
                                    <td>{{apl.created_at | date_format_day_first}}</td>
                                    <td>{{apl.attendance_time | date_format_day_first}}</td>
                                    <td v-if="apl.time_in !== null"> {{apl.time_in}} </td>
                                    <td v-else> --- </td>
                                    <td v-if="apl.time_out !== null"> {{apl.time_out}} </td>
                                    <td v-else> --- </td>
                                    <td>{{lineManagerName(apl.line_manager)}}</td>
                                    <td>{{checkStatus(apl.status)}}</td>
                                    <td class="text-center">
                                        <router-link :to="'employeeViewAttendanceCorrection/'+apl.id" data-toggle="tooltip" data-placement="top" title="View" class="action view text-center">
                                            <i class="fas fa-eye"></i>
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="rejected" role="tabpanel" aria-labelledby="rejected-tab">
                        <table id="dt-rejected" class="table">
                            <thead>
                                <tr>
                                    <th>Created At</th>
                                    <th>Correction Date</th>
                                    <th>Time IN</th>
                                    <th>Time OUT</th>
                                    <th>Line Manager</th>
                                    <th>Status</th>
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="apl in myCorrections" :key="apl.id" v-if="apl.status == 'REJECTED_HR' || apl.status == 'REJECTED_TL'">
                                    <td>{{apl.created_at | date_format_day_first}}</td>
                                    <td>{{apl.attendance_time | date_format_day_first}}</td>
                                    <td v-if="apl.time_in !== null"> {{apl.time_in}} </td>
                                    <td v-else> --- </td>
                                    <td v-if="apl.time_out !== null"> {{apl.time_out}} </td>
                                    <td v-else> --- </td>
                                    <td>{{lineManagerName(apl.line_manager)}}</td>
                                    <td>{{checkStatus(apl.status)}}</td>
                                    <td class="text-center">
                                        <router-link :to="'employeeViewAttendanceCorrection/'+apl.id" data-toggle="tooltip" data-placement="top" title="View" class="action view text-center">
                                            <i class="fas fa-eye"></i>
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="pending" role="tabpanel" aria-labelledby="pending-tab">
                        <table id="dt-pending" class="table">
                            <thead>
                                <tr>
                                    <th>Created At</th>
                                    <th>Correction Date</th>
                                    <th>Time IN</th>
                                    <th>Time OUT</th>
                                    <th>Line Manager</th>
                                    <th>Status</th>
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="apl in myCorrections" :key="apl.id" v-if="apl.status == 'WAITING' || apl.status == 'APPROVED_TL'">
                                    <td>{{apl.created_at | date_format_day_first}}</td>
                                    <td>{{apl.attendance_time | date_format_day_first}}</td>
                                    <td v-if="apl.time_in !== null"> {{apl.time_in}} </td>
                                    <td v-else> --- </td>
                                    <td v-if="apl.time_out !== null"> {{apl.time_out}} </td>
                                    <td v-else> --- </td>
                                    <td>{{lineManagerName(apl.line_manager)}}</td>
                                    <td>{{checkStatus(apl.status)}}</td>
                                    <td class="text-center">
                                        <router-link :to="'employeeViewAttendanceCorrection/'+apl.id" data-toggle="tooltip" data-placement="top" title="View" class="action view text-center">
                                            <i class="fas fa-eye"></i>
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="myCorrections === null">
            <preLoader></preLoader>
        </template>
    </div>
</template>

<script>
var approvedTable = null;
var rejectedTable = null;
var pendingTable = null;

export default {
    data() {
        return {
            myCorrections:null,
            approved: 0,
            rejected: 0,
            pending: 0,
        };
    },

    mounted() {
        this.$Progress.start();
        this.getCorrectionData();
    },

    created(){

    },
    methods: {
        lineManagerName(value){
            if(value == null){
                return '';
            }else{
                return value.name;
            }
        },
        checkStatus(status){
            if(status == 'WAITING'){
                return 'PENDING';
            }else{
                return status.replace("_", " ");
            }
        },

        dataTable(){

            approvedTable = $("#dt-approved").DataTable({
                "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r'
            });
            rejectedTable = $("#dt-rejected").DataTable({
                "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r'
            });
            pendingTable = $("#dt-pending").DataTable({
                "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r'
            });
        },

        getCorrectionData(){
            let that = this;
            axios.get('/api/myCorrectionData')
            .then(res => {
                that.rejected = 0;
                that.pending = 0;
                that.approved = 0;
                this.myCorrections = [];
                this.myCorrections = res.data.myCorrections;
                this.rejected = res.data.rejected;
                this.approved = res.data.approved;
                this.pending = res.data.pending;

                this.$Progress.finish();
            }).then(res => {
                this.dataTable();
            }).catch(err => {
                console.log(err);
            });
        }
    },
}
</script>
